import React, { KeyboardEvent, useState } from "react";
import Button from "../components/Button";
import InputField from "../components/misc/InputField";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToast from "../components/misc/CustomToast";
import logo from "../assets/images/logo.png";
import gandalf from "../assets/images/gandalf.gif";
import axios from "axios";
import LoadingScreen from "./LoadingScreen";
import { useIsMobile } from "../hooks/useIsMobile";
import { gandalfAuth } from "../utils/gandalfAuth";

const PreLogin: React.FC = () => {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleKeyDown = (
        e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handlePasswordSubmit();
        }
    };

    const handlePasswordSubmit = () => {
        if (password) {
            setLoading(true);
            const url = process.env.REACT_APP_BACKEND_URL || "";
            axios
                .post(
                    `${url}/gandalf-answer`,
                    { answer: password },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    if (response.data.success && response.data.token) {
                        toast.success(
                            <CustomToast
                                message="You shall pass!"
                                type="success"
                            />,
                            {
                                autoClose: 3000,
                            }
                        );

                        gandalfAuth.setToken(response.data.token);
                        window.location.reload();
                    } else {
                        toast.error(
                            <CustomToast
                                message="You Shall Not Pass!"
                                type="error"
                            />,
                            {
                                autoClose: 3000,
                            }
                        );
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    toast.error(
                        <CustomToast
                            message="You Shall Not Pass!"
                            type="error"
                        />,
                        {
                            autoClose: 3000,
                        }
                    );
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            toast.error(
                <CustomToast message="You shall not pass!" type="error" />,
                {
                    autoClose: 3000,
                }
            );
        }
    };

    const isMobile = useIsMobile(700);

    return (
        <main className="flex flex-col items-center justify-center h-screen px-5 bg-background">
            {loading && <LoadingScreen />}
            <section
                className={`flex flex-col items-center py-10 max-w-full bg-white rounded-2xl w-[605px] ${
                    isMobile ? "h-full m-0 justify-between px-10" : "mb-4 px-14"
                }`}
            >
                {" "}
                <header className="flex flex-col items-center space-y-4 text-2xl font-bold leading-none text-center text-primary">
                    <img
                        src={logo}
                        alt="Marabot Logo"
                        className="object-contain w-full aspect-[8.77]"
                    />
                    <h1>You Shall Not Pass!</h1>
                    <img
                        src={gandalf}
                        alt="Gandalf"
                        className="object-contain w-full"
                    />
                </header>
                <InputField
                    label="Password"
                    type="password"
                    placeholder="Gandalf needs a secret"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    showPasswordToggle
                    onKeyDown={handleKeyDown}
                />
                <Button
                    type="button"
                    text="Submit"
                    onClick={handlePasswordSubmit}
                    className="w-full mt-4"
                />
            </section>
        </main>
    );
};

export default PreLogin;
